import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Modal, Input, Form, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { getOrders, updateAOrder, sendOrderConfirmation } from "../features/auth/authSlice";

const Orders = () => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [form] = Form.useForm();
  
  const orderState = useSelector((state) => state?.auth?.orders.orders);
  const isLoading = useSelector((state) => state?.auth?.isLoading);
  const isSuccess = useSelector((state) => state?.auth?.isSuccess);
  const messageText = useSelector((state) => state?.auth?.message);

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess && messageText) {
      message.success(messageText);
    }
  }, [isSuccess, messageText]);

  const showModal = (orderId) => {
    setCurrentOrderId(orderId);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form.validateFields().then((values) => {
      dispatch(sendOrderConfirmation({ orderId: currentOrderId, awbNumber: values.awbNumber }));
      setIsModalVisible(false);
      form.resetFields();
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const updateOrderStatus = (orderId, status) => {
    dispatch(updateAOrder({ id: orderId, status: status }));
  };

  const columns = [
    {
      title: "SNo",
      dataIndex: "key",
    },
    {
      title: "Customer",
      dataIndex: "name",
    },
    {
      title: "Product",
      dataIndex: "product",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
    {
      title: "Order ID",
      dataIndex: "orderId",
    },
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Action",
      dataIndex: "action",
    },
  ];

  const data1 = [];
  for (let i = 0; i < orderState?.length; i++) {
    // Check if order is a preorder
    const isPreorder = orderState[i]?.orderStatus === "Preorder";
    
    data1.push({
      key: i + 1,
      name: `${orderState[i]?.user?.firstname} ${orderState[i]?.user?.lastname}`,
      product: (
        <Link to={`/admin/order/${orderState[i]?._id}`}>View Orders</Link>
      ),
      amount: orderState[i]?.totalPrice,
      status: isPreorder ? (
        <Tag color="blue">Preorder</Tag>
      ) : (
        <Tag color="green">{orderState[i]?.orderStatus}</Tag>
      ),
      orderId: orderState[i]?.customOrderId || `#${orderState[i]?._id?.slice(-8).toUpperCase()}`,
      awbNumber: orderState[i]?.delhivery?.waybillNumber ? (
        <Tag color="blue">{orderState[i]?.delhivery?.waybillNumber}</Tag>
      ) : (
        <Tag color="default">Not Set</Tag>
      ),
      date: new Date(orderState[i]?.createdAt).toLocaleString(),
      action: (
        <div className="d-flex gap-2">
          <select
            name=""
            defaultValue={orderState[i]?.orderStatus}
            onChange={(e) =>
              updateOrderStatus(orderState[i]?._id, e.target.value)
            }
            className="form-control form-select"
            id=""
          >
            <option value="Ordered" disabled={isPreorder}>
              Ordered
            </option>
            <option value="Preorder" selected={isPreorder}>
              Preorder
            </option>
            <option value="Processed" disabled={isPreorder}>
              Processed
            </option>
            <option value="Shipped" disabled={isPreorder}>
              Shipped
            </option>
            <option value="Out for Delivery" disabled={isPreorder}>
              Out for Delivery
            </option>
            <option value="Delivered" disabled={isPreorder}>
              Delivered
            </option>
          </select>
          <button 
            className="ms-2 btn btn-primary"
            onClick={() => showModal(orderState[i]?._id)}
          >
            Send Email
          </button>
        </div>
      ),
    });
  }

  return (
    <div className="bg-background-light dark:bg-background-dark p-4">
      <h3 className="mb-4 title text-2xl font-bold">Orders</h3>
      <div className="bg-white dark:bg-surface-dark p-2 md:p-4 rounded-xl shadow dark:shadow-gray-800">
        <Table 
          columns={columns} 
          dataSource={data1} 
          scroll={{ x: true }}
          size="small"
          pagination={{
            pageSize: 10,
            responsive: true,
            className: "text-text-light dark:text-text-dark",
          }}
        />
      </div>
      
      <Modal
        title="Send Order Confirmation Email"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ loading: isLoading }}
        width={window.innerWidth < 768 ? '90%' : 520}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="awbNumber"
            label="AWB Number"
            rules={[{ required: true, message: 'Please input the AWB number!' }]}
          >
            <Input placeholder="Enter AWB number" className="w-full" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Orders;